export default __webpack_public_path__ + "static/media/landingInfographic5.4445f252.png";